import { cn } from '@/lib/utils';

interface ProBadgeProps {
  /** Additional CSS classes */
  className?: string;
  /** Size variant */
  size?: 'sm' | 'default';
}

/**
 * Small visual badge indicating a Pro-only feature.
 *
 * Use next to feature names or menu items that require Pro mode.
 *
 * @example
 * ```tsx
 * <Button>
 *   <Lock className="h-4 w-4 mr-2" />
 *   Manage Sessions
 *   <ProBadge className="ml-2" />
 * </Button>
 * ```
 */
export function ProBadge({ className, size = 'default' }: ProBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md font-medium',
        'bg-primary/10 text-primary',
        'border border-primary/20',
        size === 'sm'
          ? 'px-1 py-0.5 text-[10px]'
          : 'px-1.5 py-0.5 text-xs',
        className
      )}
    >
      PRO
    </span>
  );
}
